import MicroModal from 'micromodal';

export default {

	init() {
		console.log('modals init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
		window.addEventListener("load", this.bindLoadEvents);
	},

	bindEvents() {
		if (!$('[data-micromodal-trigger]').length) {
			return;
		}

		$('[data-micromodal-trigger]').on('click', function (e) {
			e.preventDefault();
		});

		// Bio modal close in in header
		$('.modal-close[data-micromodal-close]').on('click', function() {
			MicroModal.close('bio');
		});

		// Initialize
		MicroModal.init({
			onShow: Modal.show,
			onClose: Modal.close,
			disableFocus: true,
			disableScroll: false
		});
	},

	bindLoadEvents() {
		const hash = window.location.hash;
		const modalId = hash.substring(1);
		let target = document.getElementById(modalId);

		if(!target || !target.classList.contains('modal')) {
			return;
		}

		// Auto-open modal in URL
		setTimeout(function() {
			MicroModal.show(modalId, {
				onShow: Modal.show,
				onClose: Modal.close,
				disableFocus: true,
				disableScroll: false
			});
		}, 2000);
	},

	show(modal, trigger, event) {
		$('html').addClass('has-modal-open').addClass('is-modal-open');
		Modal.currentModal = modal;

		if(modal.getAttribute('id') === 'bio') {
			Modal.matchModalSize();
			window.addEventListener('resize', Modal.matchModalSize);
			window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
		}

		Modal.updateUrl('#'+modal.getAttribute('id'));
	},

	close(modal, trigger, event) {
		$('html').removeClass('has-modal-open').removeClass('is-modal-open');

		if(modal.getAttribute('id') === 'bio') {
			window.removeEventListener('resize', Modal.matchModalSize);
			$('main').height('');
		}
		Modal.currentModal = null;
		Modal.updateUrl(window.location.href.split('#')[0]);
	},

	updateUrl(url) {
		if(window.history.pushState) {
			window.history.pushState({}, '', url);
		}
	},

	matchModalSize() {
		var modalHeight = Modal.currentModal.offsetHeight;
		$('main').height(modalHeight);
	},

};
